<template>
  <div>
    <!--<div class="debug">
      <div>touch: {{ touch }}, len: {{ touchLen }}</div>

      <div>
        <button @click="clear">clear</button>
        <button @click="copyFromOffscreenImg">copyFromOffscreenImg</button>
      </div>
      <div>
        pos {{ pos.x | round }},{{ pos.y | round }} , local{{
          localPos.x | round
        }}, {{ localPos.y | round }}
      </div>
    </div>-->

    <div id="canvasWrap">
      <TextInput
        :text="text"
        :tool="tool.tool"
        @input="text = $event"
        @submit="fixText"
      ></TextInput>
      <div id="textOffscreenImgContainer">
        <img
          id="textOffscreenImg"
          @load="onLoadImg"
          :src="offscreenImg"
          alt=""
        />
      </div>
      <div id="canvasContainer"></div>
    </div>
    <!--<div id="kakuninImg">
      <img :src="kakuninImg" alt="">
    </div>-->
  </div>
</template>

<script>
import Konva from "konva";
import SprayTool from "./draw/Spray";
import Marker from "./draw/Marker";
import OreCanvas from "./draw/OreCanvas";
import StageDrag from "./draw/StageDrag";
import TextInput from "./draw/TextInput";
import TextManager from "./draw/TextManager";
import { colors } from "../data/Colors";
import { showNGWord } from "../modal/ModalEvent";
import { DrawEvent } from "../events/DrawEvent";
import * as drawEventType from "../events/DrawEventType";
import { EnterFrameI } from "../events/EnterFrame";
import TextOffscreen from "./draw/TextOffscreen";
import AreaManager from "./area/AreaManager";
import * as types from "../store/modules/tool/types";
import * as modeTypes from "../store/modules/mode/types";
import * as canvasTypes from "../store/modules/canvas/canvastypes";
import { createBorder } from "./draw/BorderLayer";
import HistoryManager from "./draw/HistoryManager";
import API from "../api/API";
import * as StoreUtil from "../util/StoreUtil";
import Storage from "../api/Storage";
import ToFrontLayer from "./draw/ToFrontLayer";
import * as TweenUtil from "../util/TweenUtil";
import { loadTabletBg, copyDrawingLayerToBg, trimImg } from "./bg/BgUtil";
import { throttle } from "lodash";
import { exportCrop } from "./draw/KinsiCropper";
import {drawMaskedImage, initTabletMaskLayer} from "./tablet/TabletMask";
export default {
  name: "Canvas",
  components: {
    TextInput
  },
  data: () => {
    return {
      textOffscreen: null,
      offscreenImg: "",
      text: "",
      textManager: null,
      touch: 0,
      touchLen: 0,
      stageUtil: new StageDrag(),
      spray: new SprayTool(),
      marker: new Marker(),
      stage: null,
      isPaint: false,
      isOutside: false,
      bgLayer: null,
      tmpDrawCanvas: null,
      drawCanvas: null,
      drawingLayer: null,
      tmpDrawingLayer: null,
      drawingScope: null,
      tmpDrawingScope: null,
      dropShadowCanvas: null,
      dropShadowLayer: null,
      dropShadowScope: null,
      borderLayer: null,
      toFrontLayer: null,
      toFrontManager: null,
      tabletMaskLayer: null,
      lastPos: {},
      pos: { x: 0, y: 0 },
      localPos: { x: 0, y: 0 },
      // width: w,
      // height: h,
      kinsiLayer: null,
      mouseMoveEvent: null,
      kakuninImg: null
    };
  },
  watch: {
    isToolText() {
      this.$nextTick(() => {
        this.tmpDrawingLayer.listening(this.isToolText);
        this.tmpDrawingLayer.hitGraphEnabled(this.isToolText);
      });
      if (!this.isToolText) {
        this.resetTextTool();
      }
    },
    toolColor() {
      if (StoreUtil.isToolText() && StoreUtil.isTextInput()) this.drawText();
    },
    scale() {
      if (StoreUtil.isToolText()) this.updateTextTransByStageScale();
      this.redraw();
    },
    offset: {
      handler(val, oldVal) {
        this.redraw();
      },
      deep: true
    },
    tool2() {
      if (this.tool2 === 3) {
        this.startText();
      }
    },
    text(newVal, oldVal) {
      this.drawText();
    },
    textX() {
      this.updateTextTrans();
    },
    textY() {
      this.updateTextTrans();
    },
    textScale() {
      this.updateTextTrans();
    },
    textRot() {
      this.updateTextTrans();
    },
    mode(val) {
      console.log("watch", val);
      if (!this.stage) return;
      switch (val) {
        case modeTypes.MODE_TOP:
          this.modeTop();
          break;
        case modeTypes.MODE_AREA:
          this.modeArea();
          gtag('config', "UA-158811353-1", {page_title: "描画位置決め", page_path: "/positioning"});
          break;
        case modeTypes.MODE_TUTORIAL:
          this.modeTutorial();
          gtag('config', "UA-158811353-1", {page_title: "チュートリアル", page_path: "/tutorials"});
          break;
        case modeTypes.MODE_DRAW:
          this.modeDraw();
          gtag('config', "UA-158811353-1", {page_title: "描画キャンバス", page_path: "/drawing"});
          break;
        case modeTypes.MODE_PUBLISH:
          this.modePublish();
          break;
        case modeTypes.MODE_END:
          this.modeEnd();
          gtag('config', "UA-158811353-1", {page_title: "投稿完了", page_path: "/finish"});
          break;
        default:
          this.bgLayer.draggable(false);
          break;
      }
    }
  },
  computed: {
    pixelRatio() {
      return this.$store.state.canvas.pixelRatio;
    },
    isTablet() {
      return this.$store.state.common.isTablet;
    },
    isToolText() {
      return StoreUtil.isToolText();
    },
    toolColor() {
      return this.$store.state.tool.color;
    },
    width() {
      return this.$store.getters["canvas/stage"].width;
      // なぜかNullになる
      // return this.stage.width;
    },
    height() {
      return this.$store.getters["canvas/stage"].height;
      // return this.stage.height;
    },
    modeModule() {
      return this.$store.state.mode;
    },
    mode() {
      return this.modeModule.mode;
    },
    scale: {
      get() {
        return this.$store.state.canvas.scale;
      },
      set(value) {
        this.$store.dispatch(
          canvasTypes.namespace + canvasTypes.SET_SCALE,
          value
        );
      }
    },
    offset: {
      get() {
        return this.$store.state.canvas.offset;
      }
    },
    tool() {
      return this.$store.state.tool;
    },
    tool2() {
      return this.tool.tool;
    },
    fixedColor() {
      return colors[this.tool.color];
    },
    textX() {
      return this.tool.text.x;
    },
    textY() {
      return this.tool.text.y;
    },
    textScale() {
      return this.tool.text.scale;
    },
    textRot() {
      return this.tool.text.rotation;
    },
    stagePos() {
      return this.$store.state.touch.stagePos;
    }
  },
  mounted() {
    DrawEvent.on(drawEventType.CLEAR_CANVAS, this.clear);
    DrawEvent.on(drawEventType.REDRAW, this.redraw);
    DrawEvent.on(drawEventType.RESET, this.reset);
    DrawEvent.on(drawEventType.END_TABLET_DRAW, this.resetTablet);
    DrawEvent.on(drawEventType.CANCEL_TEXT_EDIT, this.cancelTextEdit);
    DrawEvent.on(drawEventType.COMPLETE_TEXT_EDIT, this.completeTextEdit);
    // TODO: test
    // setTimeout(() => {
    //   this.modeArea();
    // }, 1000);

    // TODO: test
    // this.tool.text.rotation = 35;
    // setTimeout(() => {
    //   this.completeTextEdit();
    // }, 1000);

    // this.textDebug("0.6", 0.6, 100, 100, 69, 2000);
    // this.textDebug("1.6", 1.6, 100, 100, 249, 4000);
    // this.textDebug("11111", 1.3, -20, 200, 0, 6000);
  },
  beforeDestroy() {
    this.removeEvents();
    this.removeHistroyEvents();
  },
  methods: {
    textDebug(text, scale, x, y, rotation, delay) {
      setTimeout(() => {
        this.scale = scale;
        this.text = text;
        this.tool.text.x = x;
        this.tool.text.y = y;
        this.tool.text.rotation = rotation;
      }, delay);
      setTimeout(() => {
        this.completeTextEdit();
      }, delay + 1000);
    },
    clear() {
      this.clearCanvas();
    },

    resetTextTool() {
      console.log("reset text!!!!!!!!!!!!!!");
      this.clearTmp(true);
    },
    reset() {
      this.clearCanvas(false);
      if (this.areaManager) this.areaManager.resetArea();
      this.historyManager.clear();
      Storage.removeDrawn(this.$store.state.concert.concertId);
    },
    resetTablet() {
      this.copyDrawlayerToBg();
      this.clearCanvas(false);
      this.historyManager.clear();
    },
    redraw() {
      if (!this.stage) return;
      console.log("stage redraw");
      this.stage.scale({ x: this.scale, y: this.scale });
      this.stage.offsetX(this.offset.x);
      this.stage.offsetY(this.offset.y);
      this.stage.batchDraw();
    },
    copyDrawlayerToBg() {
      copyDrawingLayerToBg(
        this.drawCanvas.canvas,
        this.bgLayer,
        this.stage.width(),
        this.stage.height()
      );
    },
    modeTop() {
      if (!this.stage) return;
      this.removeDrawingLayers();
      if (this.areaManager) this.areaManager.disable();
    },
    modeArea() {
      if (!this.stage) return;
      this.removeDrawingLayers();
      if (this.areaManager) this.areaManager.enable();
      this.bgLayer.batchDraw();
    },
    modeTutorial() {
      if (this.areaManager) {
        this.areaManager.disable();
        this.areaManager.updatePosition();
        this.areaManager.animateBg(0.8);
      }
      this.stage.draw();
    },
    modeDraw() {
      if (!this.stage) return;
      if (this.areaManager) this.areaManager.updatePosition();
      this.addDrawingLayers();
      this.$store.dispatch(types.namespace + types.SET_PALETTE_OPEN, true);

      // offsetをずらさないとなぜかずれる
      this.stage.offsetX(this.offset.x + 0.01);
      this.stage.draw();
      setTimeout(() => {
        this.redraw();
      }, 100);
    },
    modePublish() {
      TweenUtil.animStage(this.scale, 1.1, this.offset, { x: 0, y: 0 }, 1.25);
    },
    modeEnd() {
      this.modeDraw();
      this.borderLayer.remove();
      this.showToFront();
    },
    modeFinish() {
      this.historyManager.finish();
    },
    showToFront() {
      if (this.$store.state.common.hasDrawn)
        this.toFrontManager.load(this.$store.state.canvas.myDrawingURL);
      this.toFrontManager.show();
      if (this.kinsiLayer) this.kinsiLayer.remove();
    },
    removeKinsi() {},
    addDrawingLayers() {
      if (!this.stage) return;
      if (this.isTablet) this.stage.add(this.dropShadowLayer);
      this.stage.add(this.drawingLayer);
      this.stage.add(this.tmpDrawingLayer);
      if (!this.isTablet) {
        this.stage.add(this.kinsiLayer);
        this.stage.add(this.borderLayer);
        this.stage.add(this.toFrontLayer);
      }
      else {
        this.stage.add(this.tabletMaskLayer);
      }

      this.drawingLayer.batchDraw();
      this.stage.batchDraw();
    },
    removeDrawingLayers() {
      if (!this.stage) return;
      console.log("remove!!!!!!!!!");
      this.stage.remove(this.drawingLayer);
      this.stage.remove(this.tmpDrawingLayer);

      this.drawingLayer.remove();
      this.tmpDrawingLayer.remove();

      if (!this.isTablet) {
        this.stage.remove(this.borderLayer);
        this.stage.remove(this.toFrontLayer);
        this.borderLayer.remove();
        this.toFrontLayer.remove();
        this.toFrontManager.hide();
      }
    },

    initCanvas() {
      const info = this.$store.state.concert.info;
      // first we need to create a stage
      this.stage = new Konva.Stage({
        container: "canvasContainer", // id of container <div>
        width: this.width,
        height: this.height,
        x: this.width * 0.5,
        y: this.height * 0.5,
        offsetX: this.offset.x,
        offsetY: this.offset.y,
        scaleX: this.scale,
        scaleY: this.scale,
        draggable: false
      });
      this.textOffscreen = new TextOffscreen(this.stage);

      // then create layer
      this.bgLayer = new Konva.Layer({
        x: -this.width * 0.5,
        y: -this.height * 0.5,
        draggable: false,
        zIndex: 0,
        listening: false,
        hitGraphEnabled: false
      });

      if (!this.isTablet) {
        this.areaManager = new AreaManager(
          this.stage,
          this.width,
          this.height,
          this.$store,
          this.bgLayer
        );
      } else {
        loadTabletBg(
          this.$store.getters["concert/miniBaseBg"],
          this.$store.getters["concert/artistBg"],
          this.bgLayer,
          this.stage.width(),
          this.stage.height()
        );
      }

      const crop = this.$store.state.area.crop;
      const xx = this.isTablet ? -1920 : -crop.width * 0.5;
      const yy = this.isTablet ? -540 : -crop.height * 0.5;
      // const yy = -crop.height * 0.5;

      if (this.isTablet) {
        this.dropShadowLayer = this.createLayer("dropShadowLayer", xx, yy);
        this.tabletMaskLayer = this.createLayer("tabletMask", xx, yy, true, 1);
      }
      this.drawingLayer = this.createLayer("drawingLayer", xx, yy);
      this.tmpDrawingLayer = this.createLayer("tmpDrawingLayer", xx, yy, false);

      if (!this.isTablet) {
        this.borderLayer = this.createLayer("borderLayer", xx, yy);
        this.toFrontLayer = this.createLayer("toFrontLayer", xx, yy);
        this.toFrontManager = new ToFrontLayer(this.toFrontLayer);
        createBorder(this.borderLayer, crop, 1000, 1000);
        this.kinsiLayer = this.createLayer("kinsiLayer", xx, yy);
        this.areaManager.setKinsi(this.kinsiLayer);
      }
      this.stage.add(this.bgLayer);

      this.addDrawingLayers();

      this.drawingLayer.draw();
      this.tmpDrawingLayer.draw();

      console.log("info", info);

      this.createCanvas();

      this.drawingScope = this.createImage(this.drawCanvas.canvas, false);
      this.tmpDrawingScope = this.createImage(this.tmpDrawCanvas.canvas, false);
      this.tmpDrawingScope.zIndex(0);

      this.drawingLayer.add(this.drawingScope);
      this.tmpDrawingLayer.add(this.tmpDrawingScope);

      if (this.isTablet) {
        StoreUtil.setAreaPos(1298, 0);
        this.dropShadowScope = this.createImage(
          this.dropShadowCanvas.canvas,
          false
        );
        this.dropShadowLayer.add(this.dropShadowScope);
      }

      this.stage.draw();
      this.addEvents();

      // this.drawText();

      this.initHistory();
      console.log("this.isTablet", this.isTablet);
      if (!this.isTablet) {
        this.textManager = new TextManager();
        this.textManager.init(this.stage, this.stagePos);

        this.drawCanvas.canvas.setAttribute("id", "drawCanvas");
      } else {
        const ratio = this.pixelRatio;
        const storeCanvas = this.$store.state.canvas;
        const res = storeCanvas.sendDrawingRes;
        initTabletMaskLayer(
          this.tabletMaskLayer,
          res.width / ratio,
          res.height / ratio
        );
      }
      // this.testCanvas();
    },
    createLayer(name, x, y, fastLayer = true, pixelRatio) {
      if (!pixelRatio)
        pixelRatio = this.pixelRatio;
      const config = {
        name: name,
        x: x,
        y: y,
        listening: false,
        hitGraphEnabled: false
      };
      let result;
      if (fastLayer) {
        result = new Konva.FastLayer(config);
      } else {
        config.hitGraphEnabled = true;
        config.listening = true;
        result = new Konva.Layer(config);
      }
      return result;
    },
    testCanvas() {
      // this.drawCanvas.outline();
    },
    initHistory() {
      this.historyManager = new HistoryManager(
        this.drawCanvas,
        this.drawingLayer,
        this.$store.state.concert.concertId,
        this.$store.state.canvas.history.max,
        this.dropShadowLayer,
        this.dropShadowCanvas
      );
      this.historyManager.drawn();
      StoreUtil.setSavable(false);
      this.addHistoryEvents();
    },
    onHistoryBack() {
      StoreUtil.lock(true);
      this.historyManager.back();
      StoreUtil.setSavable(true);
    },
    onHistoryForward() {
      StoreUtil.lock(true);
      this.historyManager.forward();
      StoreUtil.setSavable(true);
    },
    onHistoryLoad() {
      const item = this.historyManager.load();
      //TODO item.textsが保存されてるテキスト
      console.log("[on history load]item", item);
      StoreUtil.restoreTexts(item.texts);
      StoreUtil.setAreaPos(item.pos.x, item.pos.y);
      if (this.areaManager) this.areaManager.loadPos(item.pos);
      StoreUtil.setSavable(true);
    },
    onHistorySave() {
      this.historyManager.save(this.$store.state.area.pos, this.$store.state.tool.text.texts);
    },
    onPublish() {
      const pos = this.$store.state.area.pos;
      // this.historyManager.save(pos);
      try {
        if (this.isTablet) this.mergeDropShadow();
        const data = this.getFinalBase64();
        console.log("pos", pos);
        DrawEvent.emit(drawEventType.PUBLISH_DATA, { data: data, pos: pos });
        //TODO
        this.kakuninImg = data;
      } catch (e) {
        alert(e);
        console.log("e", e);
      }
    },
    getFinalBase64() {
      const area = this.$store.state.area;
      if (this.isTablet) {
        return drawMaskedImage(this.drawCanvas.canvas, area.pos.x, area.pos.y, 1246, 1080);
        // const res = this.$store.state.canvas.sendDrawingRes;
        // return this.drawCanvas.getResizedBase64(res.width, res.height);
      } else {
        return exportCrop(
          this.drawCanvas.canvas,
          area.pos,
          area.crop.width,
          this.pixelRatio
        );
      }

      // const res = this.$store.state.canvas.sendDrawingRes;
      // return this.drawCanvas.getResizedBase64(res.width, res.height);
    },
    mergeDropShadow() {
      // draw → tmpに
      this.tmpDrawCanvas.drawCanvas(this.drawCanvas.canvas);
      this.drawCanvas.clear();
      //シャドウから描く
      this.drawCanvas.drawCanvas(this.dropShadowCanvas.canvas);
      this.drawCanvas.drawCanvas(this.tmpDrawCanvas.canvas);
      this.dropShadowCanvas.clear();

      this.tmpDrawingLayer.batchDraw();
      this.dropShadowLayer.batchDraw();
      this.drawingLayer.batchDraw();
    },
    startText() {
      // document.getElementById("hiddenTextField").focus();
      this.text = "";
      StoreUtil.resetTextTool();
      this.$store.dispatch(types.namespace + types.SET_PALETTE_OPEN, true);
      TweenUtil.animStage(
        this.scale,
        this.$store.state.canvas.textInputScale,
        this.offset,
        { x: 0, y: 0 }
      );
      this.drawText();
      // document.getElementById("textField1").focus();
    },
    fixPos(pos) {
      // console.log("pos", pos);
      //https://konvajs.org/docs/sandbox/Relative_Pointer_Position.html
      let node = this.drawingLayer;
      const transform = node.getAbsoluteTransform().copy();
      transform.invert();
      // const pos1 = this.stage.getPointerPosition();
      const pos1 = this.stagePos;
      // console.log("pos1", pos1);
      return transform.point(pos1);
      // return pos;
    },
    addEvents() {
      // this.stage.on("click", (e) => {
      //   console.log("e.target", e.target.name());
      // });
      this.stage.getContent().addEventListener("mousedown", this.mousedown);
      this.stage.getContent().addEventListener("touchstart", this.mousedown);
    },
    addHistoryEvents() {
      console.log("[history] add events");
      DrawEvent.on(drawEventType.HISTORY_BACK, this.onHistoryBack);
      DrawEvent.on(drawEventType.HISTORY_FORWARD, this.onHistoryForward);
      DrawEvent.on(drawEventType.HISTORY_LOAD, this.onHistoryLoad);
      DrawEvent.on(drawEventType.HISTORY_SAVE, this.onHistorySave);
      DrawEvent.on(drawEventType.PUBLISH, this.onPublish);
    },
    addEventsDrawing() {
      this.stage.addEventListener("mousemove", this.handleMousemove, {
        passive: true
      });
      this.stage.addEventListener("touchmove", this.handleMousemove, {
        passive: true
      });
      document.addEventListener("mouseup", this.mouseup);
      document.addEventListener("touchend", this.mouseup);
    },
    removeEventsDrawing() {
      this.stage.removeEventListener("mousemove", this.handleMousemove);
      this.stage.removeEventListener("touchmove", this.handleMousemove);
      document.removeEventListener("mouseup", this.mouseup);
      document.removeEventListener("touchend", this.mouseup);
    },
    removeEvents() {
      EnterFrameI.off("update", this.update);

      this.stage.getContent().removeEventListener("mousedown", this.mousedown);
      this.stage.getContent().removeEventListener("touchstart", this.mousedown);
      this.removeEventsDrawing();

      DrawEvent.off(drawEventType.CLEAR_CANVAS, this.clear);
      DrawEvent.off(drawEventType.REDRAW, this.redraw);
      DrawEvent.off(drawEventType.RESET, this.reset);
      DrawEvent.off(drawEventType.CANCEL_TEXT_EDIT, this.cancelTextEdit);
      DrawEvent.off(drawEventType.COMPLETE_TEXT_EDIT, this.completeTextEdit);
    },
    removeHistroyEvents() {
      DrawEvent.off(drawEventType.HISTORY_BACK, this.onHistoryBack);
      DrawEvent.off(drawEventType.HISTORY_FORWARD, this.onHistoryForward);
      DrawEvent.off(drawEventType.HISTORY_LOAD, this.onHistoryLoad);
      DrawEvent.off(drawEventType.HISTORY_SAVE, this.onHistorySave);
    },
    handleMousemove: throttle(function(e) {
      this.mousemove(e);
      e.preventDefault();
    }, 16),
    mousedown(e) {
      console.log("canvas mouse down");
      if (this.mode != modeTypes.MODE_DRAW) return;
      if (e.which && e.which > 1) return;
      this.touch++;
      if (e.touches) this.touchLen = e.touches.length;
      // マルチタッチならスルー
      if (this.touch > 1) return;
      this.isPaint = true;
      this.updateStagePos(e);
      this.lastPos = this.fixPos(this.stagePos);
      if (!this.isOutside) {
        this.checkOutside(this.lastPos);
      }

      this.draw();

      EnterFrameI.on("update", this.update);
      this.addEventsDrawing();
      e.preventDefault();
    },
    checkOutside(pos) {
      if (this.isTablet) {
        this.isOutside = false;
      } else {
        const crop = this.$store.state.area.crop;
        this.isOutside =
          pos.x < 0 || pos.y < 0 || pos.x > crop.width || pos.y > crop.height;
      }
    },
    mouseup() {
      console.log("mouseup");
      const paint = !this.isOutside && this.isPaint;
      if (paint) {
        this.copyCanvas();
      }
      this.touchEnd();
      EnterFrameI.off("update", this.update);
      this.removeEventsDrawing();
      if (paint) {
        this.historyManager.drawn();
        StoreUtil.setSavable(true);
      }
      else {
        // tablet でmousemove中だとdropshadow layerを履歴から復活させる
        if (this.isTablet) {
          this.historyManager.fixDropshadow();
        }
      }
      this.isPaint = false;
      this.isOutside = false;
    },
    mousemove(e) {
      if (this.touchLen > 1) {
        this.isPaint = false;
        if (this.tool.text.isTransforming) return;
        this.move(e);
      } else {
        this.updateStagePos(e);
        // this.draw();
      }
      e.preventDefault();
    },
    updateStagePos(e) {
      if (!this.isPaint) return;
      try {
        const pos = this.stage.getPointerPosition();
        if (pos) {
          StoreUtil.setStagePos(pos);
          StoreUtil.setMousePos({ x: e.clientX, y: e.clientY });
        }
      } catch (e) {
        console.log("pos------------------ e ------------", e);
      }
    },
    update() {
      if (this.isOutside) return;
      this.draw();
    },
    draw() {
      if (!this.isPaint) {
        return;
      }
      if (StoreUtil.isToolText()) return;

      // タブレットなら描き込んだらリロードさせないフラグ
      if (this.isTablet)
        StoreUtil.setNeedReload(false);

      this.updateLocalPos();
      switch (this.tool.tool) {
        case 1:
          this.drawSpray();
          break;
        case 2:
          this.drawLine();
          break;
      }

      this.lastPos = this.pos;
    },
    updateLocalPos() {
      this.localPos.x = this.lastPos.x;
      this.localPos.y = this.lastPos.y;
    },
    updateLocalPosAfter() {
      this.pos = this.fixPos(this.stagePos);
      this.localPos.x = this.pos.x;
      this.localPos.y = this.pos.y;
    },
    drawText() {
      const height = this.textManager.addText(
        this.tmpDrawingLayer,
        this.text,
        this.fixedColor,
        this.tool.text
      );
      // if (height > 90) {
      //   this.tool.text.y = 150 - height / 2;
      //   this.textManager.fixY(this.tool.text);
      //   this.tmpDrawingLayer.batchDraw();
      // }
    },
    async fixText() {
      document.getElementById("textField1").blur();
      StoreUtil.showLoading();
      const result = await API.checkNGWord(this.text);
      StoreUtil.hideLoading();
      console.log("result", result);
      if (result == "api error") {
        // show api modal
      } else if (result) {
        this.drawText();
        this.textManager.fix();
      } else {
        showNGWord();
      }

      return false;
    },
    updateTextTrans() {
      this.textManager.transform(this.tool.text);
      this.tmpDrawingLayer.batchDraw();
    },
    updateTextTransByStageScale() {
      this.$nextTick(() => {
        this.textManager.updateScale(this.tool.text.scale);
        this.tmpDrawingLayer.batchDraw();
      });
    },
    cancelTextEdit() {
      this.clearTmp(true);
      StoreUtil.resetTextTool();
      StoreUtil.textInput();
      StoreUtil.setToolSpray();
    },
    completeTextEdit() {
      this.textManager.complete();
      StoreUtil.textInput();
      this.tmpDrawingLayer.batchDraw();

      this.textOffscreen.copy(this.textManager.getTextLayer(), this.pixelRatio);
      this.offscreenImg = this.textOffscreen.toDataURL();

      //↓正常系
      // let c = this.textOffscreen.toCanvas();
      // this.drawCanvas.drawCanvasText3(c);
      // this.clearTexts();
      // this.redraw();

      // ↓safariだとワンテンポ遅らせて、imgからじゃないと転写できないという…。なにそれアホなの？
      // → img on loadにした
      //↓Safari転写テスト

      // Toolを1に戻す
      this.$store.dispatch(types.namespace + types.SET_TOOL, 1);
    },

    /**
     * Safariだとimg onload経由でしかtextLayerの転写ができない
     */
    onLoadImg() {
      console.log("on load img");
      this.copyFromOffscreenImg();
      setTimeout(() => {
        this.clearTexts();
      }, 500);
      // this.drawCanvas.drawCanvasText3(document.querySelector("#testImg-text img"));
      // this.drawingLayer.draw();
      this.redraw();
    },
    clearTexts() {
      // this.drawingLayer.draw();
      this.clearTmp(true);
      this.tmpDrawingLayer.batchDraw();
      this.$store.dispatch(types.namespace + types.SET_TOOL, 1);
    },
    copyFromOffscreenImg() {
      const img = document.getElementById("textOffscreenImg");
      // this.drawCanvas.context.drawImage(img, 0, 0);
      this.drawCanvas.drawCanvasText3(img);
      this.drawingLayer.draw();
      this.historyManager.drawn();
      StoreUtil.setSavable(true);
      this.drawingLayer.batchDraw();
    },
    drawSpray() {
      let lastPos = _.cloneDeep(this.localPos);
      this.updateLocalPosAfter();
      const ratio = this.pixelRatio;

      this.spray.draw(
        this.tmpDrawCanvas.context,
        { x: lastPos.x * ratio, y: lastPos.y * ratio },
        { x: this.localPos.x * ratio, y: this.localPos.y * ratio },
        this.tool.color,
        this.tool.size,
        this.tool.spray.alpha[this.tool.size - 1],
        ratio
      );
      this.tmpDrawingLayer.batchDraw();
      this.updateLocalPosAfter();
    },
    drawLine() {
      const ratio = this.pixelRatio;
      let lastPos = _.cloneDeep(this.localPos);
      this.updateLocalPosAfter();
      this.marker.draw(
        this.tmpDrawCanvas.context,
        { x: lastPos.x * ratio, y: lastPos.y * ratio },
        { x: this.localPos.x * ratio, y: this.localPos.y * ratio },
        this.tool.color,
        this.tool.size,
        ratio
      );
      this.tmpDrawingLayer.batchDraw();
      if (this.isTablet) {
        const offset = { x: 4, y: 4 };
        this.marker.draw(
          this.dropShadowCanvas.context,
          {
            x: (lastPos.x + offset.x) * ratio,
            y: (lastPos.y + +offset.y) * ratio
          },
          {
            x: (this.localPos.x + offset.x) * ratio,
            y: (this.localPos.y + offset.y) * ratio
          },
          // this.tool.color,
          this.tool.color == 6 ? 7 : 6,
          this.tool.size,
          ratio
        );
        this.dropShadowLayer.batchDraw();
      }
    },
    clearCanvas(addHistory = true) {
      this.drawCanvas.clear();
      this.tmpDrawCanvas.clear();
      this.drawingLayer.batchDraw();
      this.tmpDrawingLayer.batchDraw();
      if (this.isTablet) {
        this.dropShadowCanvas.clear();
        this.dropShadowLayer.batchDraw();
      }

      if (addHistory) {
        this.historyManager.drawn(true);
      }
      StoreUtil.setSavable(false);

      this.$emit("on-reset");
    },
    move(e) {
      // console.log("touch len", e.touches.length);
      // this.touchStart();
      console.log("[touch] move(e)");
      this.clearTmp();
      if (this.dropShadowCanvas)
        this.dropShadowCanvas.clear();
      const scale = this.stageUtil.move(
        e.touches[0],
        e.touches[1],
        this.stage,
        this.isTablet
      );
      this.scale = scale;
      this.offset.x = this.stage.offsetX();
      this.offset.y = this.stage.offsetY();
    },
    createCanvas() {
      const storeCanvas = this.$store.state.canvas;
      const res = this.isTablet
        ? storeCanvas.sendDrawingRes
        : this.$store.state.area.crop;
      const w = res.width;
      const h = res.height;
      const ratio = this.pixelRatio;
      this.drawCanvas = new OreCanvas(w, h, ratio);
      this.tmpDrawCanvas = new OreCanvas(w, h, ratio);
      if (this.isTablet) this.dropShadowCanvas = new OreCanvas(w, h, ratio);
    },
    createImage(canvas, listening) {
      const ratio = this.pixelRatio;
      return new Konva.Image({
        image: canvas,
        width: canvas.width / ratio,
        height: canvas.height / ratio,
        listening: listening
      });
    },
    copyCanvas() {
      this.drawCanvas.drawCanvas(this.tmpDrawCanvas.canvas);
      this.clearTmp();
      this.drawingLayer.draw();
    },
    clearTmp(removeText = false) {
      this.tmpDrawCanvas.clear();
      if (removeText) this.textManager.remove();
      this.tmpDrawingLayer.batchDraw();
    },
    touchStart() {},
    touchEnd() {
      this.touch = 0;
      this.touchLen = 0;
      this.stageUtil.end();
    }
  }
};
</script>

<style scoped lang="sass">
@import "../sass/zindex"
.image
  background: #000
#canvasWrap
  position: relative
#canvasContainer
  overflow: hidden
.controls
  input[type="range"]
    width: 30%
.hiddenText
  opacity: 0.3
  input[type="text"]
    visibility: hidden
.textareaContainer
  position: absolute
  left: 0
  top: 0
  z-index: 100
  pointer-events: none
  font-family: "arena-font2"
  textarea
    background: transparent
    border: none
    pointer-events: none
    font-size: 64px
    text-align: center
    width: 375px
    opacity: 0
    //letter-spacing: 0.1em
    &:focus
      pointer-events: all
      opacity: 0.65


.testText
  position: absolute
  top: -20px
  text-align: center
  z-index: 100
  pointer-events: none
  font-family: "arena-font"

.testImg
  border: 1px solid #ccc
  margin-top: 10px
#textOffscreenImgContainer
  display: none
  pointer-events: none
  z-index: $z_top_ui
  position: absolute
  right: 0
  top: -70px
  img
    width: 200px
    border: 3px solid white
</style>
